import * as types from 'constants/actionTypes'

const initialState = {}

export default function (state = initialState, action) {
  let newState
  switch (action.type) {

    case types.RECEIVE_SHOPIFY_ASSETS:
      newState = state.shopName === action.shopName ? {...state} : initialState
      newState.shopName = action.shopName
      newState.assets = action.assets
      newState.texts = action.texts
      newState.collections = action.collections
      newState.videos = action.videos
      return newState

    case types.RECEIVE_SHOPIFY_COLLECTION_PRODUCTS:
      // newState = clone(state)
      // newState.collections[action.collectionId].products = action.products
      return {
        ...state,
        collections: {
          ...state.collections,
          [action.collectionId]: {
            ...state.collections[action.collectionId],
            products: action.products
          }
        }
      }

    case types.LOGOUT:
      return initialState

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/shopifyAppData.js